import Index from '../views/Occurrence/Index'

let routes = {
    path: '/occurrences',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/occurrences',
            name: 'occurrences',
            component: Index,
            meta: {
                pageTitle: 'occurrence.list.title',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'occurrence.list.title',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
